import { Component, ElementRef, ViewChild } from '@angular/core';
import { Validators, FormBuilder, FormGroup, FormArray } from '@angular/forms';
import { MatAutocompleteSelectedEvent } from '@angular/material/autocomplete';
import { MatDatepickerInputEvent } from '@angular/material/datepicker';
import { Router, ActivatedRoute } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import * as moment from 'moment';
import { Observable, startWith, map } from 'rxjs';
import { Country } from 'src/app/core/models/country.model';
import { kraPintype } from 'src/app/core/models/kRAPintype.model';
import { PaymentMethod } from 'src/app/core/models/payment-method.model';
import { QuotationInfo } from 'src/app/core/models/quotations-info.model';
import { Quote } from 'src/app/core/models/quote.model';
import { Relationship } from 'src/app/core/models/relationship.model';
import { TravelPurpose } from 'src/app/core/models/travel-purpose.model';
import { Traveller } from 'src/app/core/models/traveller.model';
import { ContentLoaderService } from 'src/app/core/services/content-loader.service';
import { ErrorHandlerService } from 'src/app/core/services/error-handler.service';
import { LoaderService } from 'src/app/core/services/loader.service';
import { PolicyService } from 'src/app/core/services/policy.service';
import { RestService } from 'src/app/core/services/rest.service';

@Component({
  selector: 'app-underwriting',
  templateUrl: './underwriting.component.html',
  styleUrls: ['./underwriting.component.scss']
})
export class UnderwritingComponent {
  filteredDestinations: Observable<Country[]> | undefined;
  selectedDestinations: Country[] = [];
  @ViewChild('destinationInput') destinationInput!: ElementRef<HTMLInputElement>;
  @ViewChild('destinationInput1') destinationInput1!: ElementRef<HTMLInputElement>;
  minTripEndDate: any;
  submitted: boolean = false;
  branchSubmitted: boolean = false;
  minTripStartDate: any = new Date();
  underwritingDetailsList: any[] = [
    {
      "id": "1",
      "title": "Quote Information"
    },
    {
      "id": "2",
      "title": "Proposal Form"
    },
    {
      "id": "3",
      "title": "Travelers Information"
    },
    {
      "id": "7",
      "title": "Travelers Information"
    },
    {
      "id": "4",
      "title": "Coverages"
    },
    {
      "id": "5",
      "title": "Branch"
    },
    {
      "id": "6",
      "title": "Payment Methods"
    }
  ]
  underwritingDetails: any[]=[];
  paymentMethods: PaymentMethod[] = [];
  currentActiveIndex: string = '0';
  quotationFieldsForm = this.fb.group({
    travelPurpose: [{ value: '', disabled: true }],
    destination: [{ value: '', disabled: true }],
    tripStartDate: [{ value: '', disabled: true }],
    tripEndDate: [{ value: '', disabled: true }],
    travelingDays: [{ value: '', disabled: true }],
    numberOfTravelers: [{ value: '', disabled: true }],
  });

  proposalForm = this.fb.group({
    productName: [{ value: '', disabled: true }],
    premiumAmount: [{ value: '', disabled: true }],
    destination: [{ value: '', disabled: true }],
    tripStartDate: [{ value: '', disabled: true }],
    tripEndDate: [{ value: '', disabled: true }],
    travelingDays: [{ value: '', disabled: true }],
    numberOfTravelers: [{ value: '', disabled: true }],
    kraPinType: [{ value: '', disabled: true }],
    kraPinNumber: [{ value: '', disabled: true }],
    beneficiaryName: [{ value: '', disabled: true }],
    beneficiaryTelephoneNo: [{ value: '', disabled: true }],
    insuredOccupation: [{ value: '', disabled: true }],
    address: this.fb.group({
      houseNumber: [{ value: '', disabled: true }],
      roadName: [{ value: '', disabled: true }],
      pincode: [{ value: '', disabled: true }]
    }),
  });

  paymentMethodsForm = this.fb.group({
    paymentMode: ['', Validators.required],
    quotationReferenceNumber: ['']
  });

  branchForm = this.fb.group({
    branch: ['']
  });

  travelersForm = this.fb.group({
    travelersDetails: this.fb.array([])
  });

  quotationId: string = '';
  quotesId: string = '';
  countryCodes: any[] = [];
  getTravelPurposeList: TravelPurpose[] = [];
  getCountriesList: Country[] = [];
  relationshipList: Relationship[] = [];
  selectedProduct!: Quote;
  quotationInfo!: QuotationInfo;
  travellerList: Traveller[] = [];
  coverages: any[] = [];
  dateOfBirthMaxDate = moment().subtract(1, 'years');
  messages = [
    "We're crafting your policy. Thanks for waiting!",
    "Your policy is on its way. Hang in there!",
    "Just a moment longer for your custom policy.",
    "We're working on your policy. Almost done!",
    "Thanks for your patience while we generate your policy.",
    "Sit tight! Your policy is being tailored.",
    "Your policy is in progress. Appreciate your patience!",
    "Just a few more seconds for your personalized policy.",
    "Your policy is getting ready. Thanks for waiting!",
    "We're on it! Your policy will be ready soon."
  ];
  currentMessage!: string;
  buyPolicyFormSubmitted: boolean = false;
  fetchUserOrgGroupList: any[] = [];
  isDisablePayment: boolean = true;
  activeIndex: any = "1";
  kRAPintypeList: kraPintype[] = [];
  branchFilteredOptions: Observable<any[]> | undefined;
  productDetails: any[] = [];
  coveragesList: any[] = [];
  isBulkUpload:boolean=false;
  userProposalBulkList:any[]=[];
   currentLanguage: string = '';

  constructor(
    private fb: FormBuilder,
    private restService: RestService,
    private loader: LoaderService,
    private router: Router,
    private route: ActivatedRoute,
    private policyService: PolicyService,
    private contentLoaderService: ContentLoaderService,
    private errorHandler: ErrorHandlerService,
     private translate: TranslateService
  ) {
    this.route.params.subscribe(params => {
      this.quotationId = params['quotationId'];
      this.quotesId = params['quotesId'];
    });

    this.filteredDestinations = this.proposalForm.get("destination")?.valueChanges.pipe(
      startWith(''),
      map(value => this._filter(value || ''))
    ) as Observable<Country[]>;
    this.paymentMethodsForm.get('paymentMode')?.valueChanges.subscribe((paymentMode) => {
      const quotationRefControl = this.paymentMethodsForm.get('quotationReferenceNumber');
      if (!quotationRefControl) {
        return;
      }
      if (paymentMode === '93ca7eec-e630-48ff-b3b4-352939a2648d') {
        quotationRefControl.setValidators([Validators.required]);
      } else {
        quotationRefControl.clearValidators();
      }
      quotationRefControl.updateValueAndValidity();
    });
     this.currentLanguage = this.translate.currentLang;
     this.translate.onLangChange.subscribe((event: any) => {
      this.currentLanguage = event.lang;
     })
  }

  ngOnInit() {
    this.GetMasterData();
    this.FetchUsersOrgGroups();
    this.QuotationCompare();
    // this.GetUserProposalBulk();
  }

  QuotationCompare() {
    let params = {
      QuotationID: this.quotationId
    }
    this.loader.show();
    this.restService.postData(params, 'api/Quotation/QuotationB2CCompare').subscribe(
      {
        next: (data: any) => {
          try {
            if (data.rcode == 200) {
              this.coveragesList = data.rObj.Coverages;
              this.productDetails = data.rObj.QuotationCompare.filter((item: any) => item.QuotesID == this.quotesId).map((item: any) => ({
                ProductID: item.ProductID,
                ProductName: item.ProductName,
                coverageQuotesCompare: item.coverageQuotesCompare.reduce((acc: any, coverage: any) => {
                  acc[coverage.CoverageID] = coverage.additionalData.reduce((adAcc: any, ad: any) => {
                    adAcc[ad.AdditionalCoverageID] = ad.AdditionalCoverageDescriptionUserLimit;
                    return adAcc;
                  }, {});
                  return acc;
                }, {})
              }));



            } else {
              this.errorHandler.handleRcodeError(data);
            }
          } catch (error) {
            this.errorHandler.internalError();
          } finally {
            this.loader.hide();
          }
        },
        error: (error: any) => {
          this.loader.hide();
          this.errorHandler.handleStatusError(error);
        }
      })
  }

  dateOfBirthChange(event: MatDatepickerInputEvent<Date>, index: number) {
    let dob = this.getTravelersDetails.at(index).get('dateOfBirth')?.value;
    let getAge = this.calculateAge(dob);
    this.getTravelersDetails.at(index).get('age')?.patchValue(getAge);
  }

  FetchUsersOrgGroups() {
    let params = {
      typeCodeNum: "1400"
    }
    this.loader.show();
    this.restService.postDataDs(params, 'api/digital/core/User/FetchUsersOrgGroups').subscribe(
      {
        next: (data: any) => {
          try {
            if (data.rcode == 200) {
              this.fetchUserOrgGroupList = data.rObj.fetchUserOrgGroup || [];
              this.branchFilteredOptions = this.branchForm.get('branch')?.valueChanges.pipe(
                startWith(''),
                map((value: any) => {
                  const name = typeof value === 'string' ? value : value?.orgGroupName;
                  return name ? this._branchFilter(name as string) : this.fetchUserOrgGroupList.slice();
                }),
              );
            } else {
              this.errorHandler.handleRcodeError(data);
            }
          } catch (error) {
            this.errorHandler.internalError();
          } finally {
            this.loader.hide();
          }
        },
        error: (error: any) => {
          this.loader.hide();
          this.errorHandler.handleStatusError(error);
        }
      })
  }
  branchDisplayFn(branch: any): string {
    return branch && branch.orgGroupName ? branch.orgGroupName : '';
  }

  private _branchFilter(branch: string): any[] {
    const filterValue = branch.toLowerCase();

    return this.fetchUserOrgGroupList.filter(option => option.orgGroupName.toLowerCase().includes(filterValue));
  }
  GetMasterData() {
    this.loader.show();
    this.restService.postData({
    "id": this.currentLanguage == 'en' ? '1' : '2', // Assuming 1 is for English and 2 for other languages
}, 'api/Quotation/GetMasterData').subscribe(
      {
        next: (data: any) => {
          try {
            if (data.rcode == 200) {
              this.getTravelPurposeList = data.rObj.GetTravelPurpose || [];
              this.getCountriesList = data.rObj.GetCountries || [];
              this.relationshipList = data.rObj.Relationship || [];
              this.paymentMethods = data.rObj.PaymentMethods || [];
              this.countryCodes = data.rObj.CountryCode || [];
              this.kRAPintypeList = data.rObj.kRAPintype || [];
              this.GetQuotesUserInfo();
            } else {
              this.errorHandler.handleRcodeError(data);
            }
          } catch (error) {
            this.errorHandler.internalError();
          } finally {
            this.loader.hide();
          }
        },
        error: (error: any) => {
          this.loader.hide();
          this.errorHandler.handleStatusError(error);
        }
      })
  }

  GetQuotesUserInfo() {
    let params = {
      QuotationID: this.quotationId,
      QuotesID: this.quotesId
    }
    this.loader.show();
    this.restService.postData(params, 'api/Quotation/UserInfo').subscribe(
      {
        next: (data: any) => {
          try {
            if (data.rcode == 200) {
              this.quotationInfo = data.rObj.Quotations;
              this.isBulkUpload=this.quotationInfo.IsBulk;
              this.underwritingDetails = this.underwritingDetailsList.filter(urd => {
                return ((!this.isBulkUpload && !["7"].includes(urd.id)) || (this.isBulkUpload && !["2", "3"].includes(urd.id)));
              });
              
              this.selectedProduct = data.rObj.Quotes;
              this.travellerList = data.rObj.Traveller || [];
              this.coverages = data.rObj.Coverages || [];
              let selectedDestinationsList = data.rObj.DestinationCountry || [];
              let selectedDestinationsIds = selectedDestinationsList.map((sdl: any) => sdl.DestinationCountryID);
              this.selectedDestinations = this.getCountriesList.filter(country => selectedDestinationsIds.includes(country.TocountryID));
              this.SetValuesToForms();
              this.numberOfTravelers();
            } else {
              this.errorHandler.handleRcodeError(data);
            }
          } catch (error) {
            this.errorHandler.internalError();
          } finally {
            this.loader.hide();
          }
        },
        error: (error: any) => {
          this.loader.hide();
          this.errorHandler.handleStatusError(error);
        }
      })
  }

  SetValuesToForms() {
    this.quotationFieldsForm.patchValue({
      destination: '',
      travelPurpose: this.quotationInfo.TravelPurposeID,
      tripStartDate: this.quotationInfo.FromDate,
      tripEndDate: this.quotationInfo.ToDate,
      travelingDays: this.quotationInfo.NoofDays?.toString(),
      numberOfTravelers: this.quotationInfo.NoofTravellers?.toString()
    });


    this.proposalForm.patchValue({
      productName: this.selectedProduct.ProductName,
      premiumAmount: this.selectedProduct.sTotalAmount,
      destination: '',
      tripStartDate: this.quotationInfo.FromDate,
      tripEndDate: this.quotationInfo.ToDate,
      travelingDays: this.quotationInfo.NoofDays?.toString(),
      numberOfTravelers: this.quotationInfo.NoofTravellers?.toString(),
      kraPinType: this.quotationInfo.KRAPinTypeID,
      kraPinNumber: this.quotationInfo.KRAPinNumber,
      insuredOccupation: this.quotationInfo.Occupation,
      beneficiaryName: this.quotationInfo.BeneficiaryName,
      beneficiaryTelephoneNo: this.quotationInfo.BeneficiaryPhoneNumber,
      address: {
        houseNumber: this.quotationInfo.AddressLine1,
        roadName: this.quotationInfo.AddressLine2,
        pincode: this.quotationInfo.AddressLine3
      },
    });
  }

  changeActiveIndex(index: string) {
    this.activeIndex = index;
  }

  numberOfTravelers(): void {
    this.getTravelersDetails.clear();
    for (const traveller of this.travellerList) {
      this.getTravelersDetails.push(this.newTravelersDetaile(traveller));
    }
  }

  newTravelersDetaile(traveller: Traveller): FormGroup {
    return this.fb.group({
      isProposerATraveller: [{ value: traveller.IsPolicyHolder, disabled: true }],
      firstName: [{ value: traveller.FirstName, disabled: true }],
      lastName: [{ value: traveller.LastName, disabled: true }],
      nameAsPerThePassport: [{ value: traveller.Fullname, disabled: true }],
      dateOfBirth: [{ value: traveller.DOB, disabled: true }],
      age: [{ value: traveller.Age, disabled: true }],
      // mobileCode: [{ value: traveller.PhoneNumberCountryCode, disabled: true }],
      mobileCode: [{ value: '5bde1eaa-2cd1-4a46-ad1f-a1b21020bdae', disabled: true }],
      mobileNumber: [{ value: traveller.PhoneNumber, disabled: true }],
      emailId: [{ value: traveller.EmailId, disabled: true }],
      passportNumber: [{ value: traveller.PolicyHolderPassPortNumber, disabled: true }],
      relationshipWithTheProposer: [{ value: traveller.RelationshipTypeID, disabled: true }],
      passportFile: [{ value: '', disabled: true }],
      passportFileAttachmentID: [{ value: traveller.PassportAttachmentID, disabled: true }],
    })
  }

  get getTravelersDetails(): FormArray {
    return this.travelersForm.get("travelersDetails") as FormArray;
  }

  remove(destination: Country): void {
    const index = this.selectedDestinations.indexOf(destination);
    if (index >= 0) {
      this.selectedDestinations.splice(index, 1);
      // this.onFocus();
    }
  }

  DownloadPassportCopy(index: number) {
    let attachmentID = this.getTravelersDetails.at(index).get('passportFileAttachmentID')?.value
    let params = {
      AttachmentID: attachmentID
    }
    this.loader.show();
    this.restService.postData(params, 'api/Download/DownloadUserProfile').subscribe(
      {
        next: (data: any) => {
          try {
            if (data.rcode == 200) {
              if (data.rObj.URL) {
                window.open(data.rObj.URL, '_target');
              }
            } else {
              this.errorHandler.handleRcodeError(data);
            }
          } catch (error) {
            this.errorHandler.internalError();
          } finally {
            this.loader.hide();
          }
        },
        error: (error: any) => {
          this.loader.hide();
          this.errorHandler.handleStatusError(error);
        }
      })
  }

  selected(event: MatAutocompleteSelectedEvent): void {
    const selectedCountry = this.getCountriesList.find(country => country.TocountryID === event.option.value);
    if (selectedCountry) {
      this.selectedDestinations.push(selectedCountry);
      this.destinationInput.nativeElement.value = '';
      this.proposalForm.get('destination')?.patchValue('');
      // this.onFocus();
    }
  }

  onFocus() {
    this.filteredDestinations = this.proposalForm.get("destination")?.valueChanges.pipe(
      startWith(''),
      map(value => this._filter(value || ''))
    ) as Observable<Country[]>;
  }

  private _filter(value: string): Country[] {
    const filterValue = value.toLowerCase();
    return this.getCountriesList.filter(country =>
      country.ToCountryName.toLowerCase().includes(filterValue) &&
      !this.selectedDestinations.some(selected => selected.TocountryID === country.TocountryID)
    );
  }


  numberOnly(event: any) {
    const charCode = (event.which) ? event.which : event.keyCode;
    if (charCode > 31 && (charCode < 48 || charCode > 57)) {
      return false;
    }
    return true;
  }

  calculateAge(dob: Date): number {
    const today = new Date();
    const birthDate = new Date(dob);
    let age = today.getFullYear() - birthDate.getFullYear();
    const m = today.getMonth() - birthDate.getMonth();
    if (m < 0 || (m === 0 && today.getDate() < birthDate.getDate())) {
      age--;
    }
    return age;
  }

  goBack() {
    this.router.navigate(['quotation/proposal-form', this.quotationId, this.quotesId]);
  }

  buyPolicy1() {
    this.submitted = true;
    if (this.paymentMethodsForm.invalid) {
      return;
    }
    let params = {
      QuotationID: this.quotationId,
      PaymentMethodID: this.paymentMethodsForm.get('paymentMode')?.value
    }
    this.loader.show();
    this.restService.postData(params, 'api/Quotation/QuotationStatusUpdate').subscribe(
      {
        next: (data: any) => {
          try {
            if (data.rcode == 200) {
              // this.policyService.setPolicyId(data.rObj.policyNo);
              this.router.navigate(['policy/policy-purchase-details']);
            } else {
              this.errorHandler.handleRcodeError(data);
            }
          } catch (error) {
            this.errorHandler.internalError();
          } finally {
            this.loader.hide();
          }
        },
        error: (error: any) => {
          this.loader.hide();
          this.errorHandler.handleStatusError(error);
        }
      })
  }

  buyPolicySubmit() {
    this.submitted = true;
    if (this.paymentMethodsForm.invalid) {
      return;
    }

    if (this.paymentMethodsForm.get('paymentMode')?.value == '5d3154a9-5d2e-4c84-915e-b62b5ea2670a') {
      this.router.navigate(['policy/payment-form', this.quotationId, this.quotesId]);
    } else {
      this.buyPolicy();
    }
  }

  buyPolicy() {
    let params = {
      quotationReferenceNumber: this.paymentMethodsForm.get('quotationReferenceNumber')?.value || null,
      QuotationID: this.quotationId,
      PaymentMethodID: this.paymentMethodsForm.get('paymentMode')?.value
    }
    this.buyPolicyFormSubmitted = true;
    this.contentLoaderService.submitData('api/Quotation/QuotationStatusUpdate', params, this.messages).subscribe(
      {
        next: (data: any) => {
          try {
            if (typeof data === 'string') {
              this.currentMessage = data;
            }
            else if (data.rcode == 200) {
              this.policyService.setPolicyPaymentDetailes(data.rObj.policyNo, data.rObj.ReferenceNumber, false, '');
              this.router.navigate(['policy/policy-purchase-details']);
            }
            else if (data.rcode == 201) {
              this.policyService.setPolicyPaymentDetailes(data.rObj.policyNo, data.rObj.ReferenceNumber, true, data.rObj.ResponseMessage);
              this.router.navigate(['policy/policy-purchase-details']);
            }
            else {
              this.errorHandler.handleRcodeError(data);
            }
          } catch (error) {
            this.errorHandler.internalError();
          }
        },
        error: (error) => {
          this.errorHandler.handleStatusError(error);
        }
      }
    );
  }

  BranchUpdate() {
    // this.branchSubmitted=true;
    if (!this.branchForm.get('branch')?.value || !(typeof this.branchForm.get('branch')?.value === 'object')) {
      this.activeIndex = "6";
      this.isDisablePayment = false;
      return;
    }
    let selectedBranch: any = this.branchForm.get('branch')?.value;

    let params = {
      quotationID: this.quotationId,
      branchId: selectedBranch?.orgGroupID || null,
      branchName: selectedBranch?.orgGroupName || null,
    }
    this.loader.show();
    this.restService.postData(params, 'api/Quotation/BranchUpdate').subscribe(
      {
        next: (data: any) => {
          try {
            if (data.rcode == 200) {
              this.activeIndex = "6";
              this.isDisablePayment = false;
            } else {
              this.errorHandler.handleRcodeError(data);
            }
          } catch (error) {
            this.errorHandler.internalError();
          } finally {
            this.loader.hide();
          }
        },
        error: (error: any) => {
          this.loader.hide();
          this.errorHandler.handleStatusError(error);
        }
      })
  }

  GetUserProposalBulk() {
    let params={
      quotationID:this.quotationId,
      quotesID:this.quotesId
    }
    this.loader.show();
    this.restService.postData(params, 'api/Quotation/GetUserProposalBulk').subscribe(
      {
        next: (data: any) => {
          try {

            if (data.rcode == 200) {
              this.userProposalBulkList=data.rObj.GetUserProposalBulk || [];
              this.userProposalBulkList = this.userProposalBulkList.map(up => {
                up.eRRORMESSAGE = up.eRRORMESSAGE ? JSON.parse(up.eRRORMESSAGE) : [];
                return up;
              });
              
            }
            else if (data.rcode == 504) {
              this.errorHandler.hasOverlappingPassportDatesError(data);
            } 
             else {
              this.errorHandler.handleRcodeError(data);
            }
          } catch (error) {
            this.errorHandler.internalError();
          } finally {
            this.loader.hide();
          }
        },
        error: (error: any) => {
          this.loader.hide();
          this.errorHandler.handleStatusError(error);
        }
      });
  }
}
